export const CONSUMPTION_POINT_ADD_UPDATE = 'CONSUMPTION_POINT_ADD_UPDATE';
export const CONSUMPTION_POINT_EDIT = 'CONSUMPTION_POINT_EDIT';
export const CONSUMPTION_POINT_CREATE = 'CONSUMPTION_POINT_CREATE';
export const AVP_POINTS_FETCH = 'CONSUMPTION_POINT_AVP_POINTS_FETCH';
export const CONSUMER_FETCH = 'CONSUMPTION_POINT_CONSUMER_FETCH';
